import { requests } from '../../../RestFullApi/api'
import {companieDetailType} from "./getCompaniesType";

export const getCompanies = {
    getCompanies: (): Promise<companieDetailType[]> =>
        requests.get(`yoptimize/companys/`),
}
